// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperSideNav_root__UA6WY","tabs":"LayoutWrapperSideNav_tabs__CMO5D","tab":"LayoutWrapperSideNav_tab__mnQKZ"};